export default __webpack_public_path__ + "static/media/call.a69350a8.svg";